module.exports = __webpack_public_path__ + "img/查询结果banner.e24380de.png";